// extracted by mini-css-extract-plugin
export default {"card":"YV","autoAlign":"ZV","cardrow":"aW","cardcentered":"bW","details":"cW","imgwrapper":"eW","img":"fW","category":"gW","name":"hW","copy":"iW","detailsbtn":"jW","remove":"kW","price":"lW","netPrice":"mW","regularPrice":"nW","label":"oW"};
    if(module.hot) {
      // 1738064243152
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  